import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import React, { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup, useClosePopupOnNavigation } from '@gem/popups';
import { Button } from '@gem/ui-kit';
import { getMascotImageSrc } from '@gem/utils';

import { useTrustedDeviceRequestPopupPresenter } from './TrustedDeviceRequestPopup.presenter';
import styles from './TrustedDeviceRequestPopup.styles.m.css';

interface ITrustedDeviceRequestPopupProps {
  deviceId: string;
}

export const TrustedDeviceRequestPopup: FC<ICommonPopupsProps<ITrustedDeviceRequestPopupProps>> =
  observer((props) => {
    const { t } = useTranslation();
    const presenter = useTrustedDeviceRequestPopupPresenter(props);
    useClosePopupOnNavigation(props.popupInstance);

    return (
      <Popup
        isOpened
        isHidden={props.popupInstance.isHidden}
        onClose={presenter.onClose}
        className={styles.popup}
      >
        <div className={classNames(styles.wrapper)}>
          <img
            src={getMascotImageSrc('ic-secure-confirm.png')}
            className={styles.logo}
            alt={''}
          />
          <h1 className={styles.title}>{t('trusted_device_new_sign_in_request_title')}</h1>
          <div className={styles.device}>
            {presenter.deviceName} &#183; {presenter.deviceOS}
          </div>
          <div className={styles.time}>{presenter.activity}</div>
          <div className={styles.bottomDescription}>
            {t('trusted_device_sign_in_request_description')}
          </div>
          <div className={styles.bottomDescription}>
            {t('trusted_device_sign_in_request_denied_hint')}
          </div>
          <div className={styles.bottomDescription}>
            {t('secure_chat_history_unavailable_banner')}
          </div>
          <Button
            size={'20'}
            className={styles.approveButton}
            onClick={presenter.onApprove}
            isLoading={presenter.isLoading}
            theme="primary"
          >
            {t('trusted_device_yes_its_me')}
          </Button>
          <Button
            size={'20'}
            className={styles.blockButton}
            isLoading={presenter.isLoading}
            onClick={presenter.onBlock}
            theme="text-error"
          >
            {t('trusted_device_no_block_access')}
          </Button>
        </div>
      </Popup>
    );
  });
